import axiosInstance from '@/utils/api.js'

var state = {
  license: []
}

var getters = {
  LICENSE: (state) => {
    return state.license
  }
}

var mutations = {
  SET_LICENSE: (state, payload) => {
    state.license = payload
  }
}

var actions = {
  GET_LICENSE: async (context, payload) => {
    let result = await axiosInstance.get('/settings/license')
    if (result.status === 200) {
      context.commit('SET_LICENSE', result.data)
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/settings/license.js